// Chat widget presentation copy. The site owns the chrome (heading, teaser,
// quick replies, thank-you); the core owns the in-thread welcome/feedback lines.
export const chatWidgetCopy = {
  heading: "Scotty's Land Specialist",
  subheading: "Highland, Utah",
  teaser: "Need a quote or have a question? Chat with us.",
  quickReplies: [
    "Land clearing",
    "Dumpster rental",
    "Weed control",
    "Snow removal",
  ],
  launcherAriaLabel: "Open chat with Scotty's Land Specialist",
  closeAriaLabel: "Close chat",
  sendAriaLabel: "Send message",
  attachAriaLabel: "Attach a file",
  backAriaLabel: "Back",
};
